var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "homeheader"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "containers"
  }, [_c('div', {
    staticClass: "top",
    class: {
      'topbar-scroll-bg': _vm.leaveTop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHeader,
      expression: "showHeader"
    }],
    staticClass: "container top"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": _vm.getHeaderLink('/')
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('首页');
      }
    }
  }), _vm._v(" "), _vm.isJmt ? _c('a', {
    staticClass: "logo-jmt",
    attrs: {
      "href": "https://babyou.nownews.com/",
      "target": "_blank"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "right-header menu",
    on: {
      "click": function click($event) {
        return _vm.changeMenu(false);
      }
    }
  }), _vm._v(" "), _vm.islogined ? _c('div', {
    staticClass: "login_info right-header"
  }, [_c('span', {
    staticClass: "face",
    style: _vm.userFace,
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "nickname",
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      }
    }
  }, [_vm._v(_vm._s(_vm.userInfo && _vm.userInfo.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "logout",
    class: {
      none: _vm.logoutDisplay
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.showLogout();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hideLogout();
      },
      "click": function click($event) {
        return _vm.logoutAction();
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('logOut')) + "\n              ")])]) : _c('div', {
    staticClass: "logwrap right-header"
  }, [_c('a', {
    staticClass: "login logwrap_login",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doLogin();
      }
    }
  }, [_vm._v(_vm._s("".concat(_vm.$t('signIn'), " / ").concat(_vm.$t('userSign.signUp'))))])]), _vm._v(" "), _c('nft-wallets', {
    staticClass: "right-header",
    attrs: {
      "islogined": _vm.islogined
    },
    on: {
      "changeLoginState": _vm.logoutHandle
    }
  }), _vm._v(" "), _vm.islogined ? _c('a', {
    staticClass: "recharge_wrap right-header"
  }, [_c('span', {
    staticClass: "recharge_txt"
  }, [_vm._v(_vm._s(_vm.$t('wallet')))]), _vm._v(" "), _c('div', {
    staticClass: "recharge_list"
  }, [_c('a', {
    staticClass: "convert",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doConvert();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('convertToCoins')))]), _vm._v(" "), _c('a', {
    staticClass: "cash",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doCashOut();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cashOut')))])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "right-header",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        return _vm.doRecharge();
      }
    }
  }, [_c('span', {
    staticClass: "recharge_txt"
  }, [_vm._v(_vm._s(_vm.$t('recharge')))])]), _vm._v(" "), _c('a', {
    staticClass: "right-header explore",
    class: _vm.getCurrentStatus == 'explore' ? 'current' : '',
    attrs: {
      "href": _vm.getHeaderLink('/explore.html')
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/explore.html');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('explorePage')))]), _vm._v(" "), _c('a', {
    staticClass: "right-header guild-settlement",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://docs.google.com/forms/d/15RWE2FYzRVwr0xaCCkOmp4lDldY6G84ElVnWy78JUc8/edit"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('guildSettlement')) + "\n            ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "top toprelative"
  }), _vm._v(" "), _c('right-menu', {
    attrs: {
      "closeState": _vm.closeState,
      "changeMenu": _vm.changeMenu
    }
  }), _vm._v(" "), _c('loginReg', {
    ref: "logReg",
    attrs: {
      "success": _vm.successHandle,
      "logout": _vm.logoutHandle
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };